import { MutableRefObject, useEffect, useMemo, useState } from "react";

type IntersectionState = "visible" | "above" | "below";

export function useObserveIntersection(
  ref: MutableRefObject<HTMLElement | null>,
  rootRef?: MutableRefObject<HTMLElement | null>,
) {
  const [intersectionState, setIntersectionState] =
    useState<IntersectionState | null>(null);

  const intersectionObserver = useMemo(
    () =>
      new IntersectionObserver(
        ([el]) => {
          if (el.isIntersecting) setIntersectionState("visible");
          else if (el.boundingClientRect.y <= (el.rootBounds?.top ?? 0))
            setIntersectionState("above");
          else setIntersectionState("below");
        },
        {
          root: rootRef?.current,
        },
      ),
    [rootRef?.current],
  );

  useEffect(() => {
    if (ref.current) intersectionObserver.observe(ref.current);

    return () => intersectionObserver.disconnect();
  }, [ref.current, intersectionObserver]);

  const isIntersecting = intersectionState === "visible";

  return { intersectionState, isIntersecting };
}
